import React, {useState} from 'react';
import DatePicker from "@amzn/meridian/date-picker";
import Moment from "moment";
import Box from "@amzn/meridian/box";

/**
 * This component will render date filter across app
 * @param onChangeDate
 * @returns {JSX.Element}
 * @constructor
 */
const DateFilter = (props) => {
    const {initialDate,onChangeDate} = props;
    const [value, setValue] = useState(Moment(initialDate).format('YYYY-MM-DD'));
    function checkDate(date) {
        let current_date = Moment();
        let input_date = Moment(date);
        let start_date = Moment().subtract(3, "months");
        return input_date < start_date || input_date > current_date;
    }

    function updateData(date) {
        setValue(date);
        onChangeDate(date);
    }

    return <Box spacingInset="small none none none"><DatePicker value={value} onChange={date => updateData(date)} size="medium"
                            disabledDates={date => checkDate(date)} placeholder="DD/MM/YYYY"/></Box>
}

export default DateFilter;


// WEBPACK FOOTER //
// ./src/component/common/dateFilter.js